import React, {useState} from 'react';
import AppVersionCardProperties from './AppVersionCardProperties';
import {useStyles} from './AppVersionCard.style';
import Button from '../../../ui_components/Button/Button';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import DownloadIcon from '@mui/icons-material/Download';
import {Config} from '../../../util/Config';
import {RestClient} from '../../../util/RestClient';
import {Downloader} from '../../../util/Download';
import Request from '../../../model/Request';
import {APP_DOWNLOAD_NAME_PREFIX} from '../AppVersions.data';

const AppVersionCard: React.FC<AppVersionCardProperties> = ({
    appVersion,
    latest = false,
}) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    const downloadName = `${APP_DOWNLOAD_NAME_PREFIX}${appVersion.version}`;

    const onClick = async () => {
        setLoading(true);
        const url = Config.get("DOWNLOAD_APP_URL", {fileName: downloadName});
        const response = await RestClient.get(new Request(url));
        if (response.success) {
            Downloader.downloadBase64(response.data?.fileName || `${downloadName}.apk`, response.data?.data);
        }
        setLoading(false);
    }

    return (
        <div className={classes.card_container}>
            <div className={classes.header_container}>
                <div className={classes.version_info_container}>
                    <div className={classes.version_text}>Versión {appVersion.version}</div>
                    {latest && <div className={classes.latest_badge}>Última versión</div>}
                </div>
                <Button
                    text={'Descargar'}
                    loading={loading}
                    size={ButtonSize.SMALL}
                    type={ButtonType.SECONDARY}
                    onClick={onClick}
                    startIcon={<DownloadIcon/>}
                />
            </div>
            <ul className={classes.changes_list}>
                {appVersion.changes.map((change, i) => (
                    <li key={i}>{change}</li>
                ))}
            </ul>
        </div>
    )
}

export default AppVersionCard;
